import { asStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import type { TeamListItem as TeamListItemType } from "@bezoned/shared/types/api/team/team-list.types.js";
import { Tooltip } from "@fluentui/react-components";

import { cn } from "../../../utils/tailwind-class-merge.js";
import { STARTER_DEFAULT_OFFICE_ONLY_MESSAGE } from "../../subscription/starter-plan-copy.js";

interface TeamListItemProps {
  team: TeamListItemType;
  index: number;
  onSelect: (team: TeamListItemType) => void;
  highlighted?: boolean;
}

export const TeamListItem = ({
  team,
  index,
  onSelect,
  highlighted = false,
}: TeamListItemProps) => {
  const isRestricted = team.accessRestrictedReason !== null;
  const content = (
    <button
      className={cn(
        "bg-bzd-purple-300 relative mb-4 w-full rounded-md p-4 text-left text-lg font-medium text-white transition-colors ease-in-out",
        isRestricted
          ? "bg-bzd-gray-100 text-bzd-gray-500 border-bzd-gray-500 cursor-not-allowed border border-dashed"
          : "hover:bg-bzd-purple-200 cursor-pointer"
      )}
      data-testid={`choose-team-${index}`}
      disabled={isRestricted}
      onClick={asStableCallback(() => {
        if (!isRestricted) {
          onSelect(team);
        }
      })}
      type="button"
    >
      {highlighted ? (
        <Tooltip content="New" relationship="label">
          <span className="group absolute top-0 right-0 z-10 flex size-8 translate-x-1/2 -translate-y-1/2 cursor-help items-center justify-center">
            <span className="bg-bzd-red-400 size-4 rounded-full transition-transform duration-150 ease-out group-hover:scale-125" />
          </span>
        </Tooltip>
      ) : null}
      <span>{team.name}</span>
    </button>
  );

  if (!isRestricted) {
    return content;
  }

  return (
    <Tooltip content={STARTER_DEFAULT_OFFICE_ONLY_MESSAGE} relationship="label">
      <span className="block">{content}</span>
    </Tooltip>
  );
};
